// eslint-disable-next-line import/no-anonymous-default-export
export default {
    loginStatus: {
        result: false,
        data: "-",
    },
    popUp: "none",
    posts: [],
    users: [],
    userPosts: [],
};
